<template>
  <main class="overflow-hidden has-sidebar inbox">
    <nav class="nav sidebar pt-4">
      <h6 class="d-flex align-items-center justify-content-between px-3 mb-4">
        <span class="bold">{{title}}</span>
      </h6>
      <ul class="nav flex-column">
        <li class="nav-item" v-for="room in property.rooms">
          <router-link v-bind:to="'/rooms/' + room._id" class="nav-link">
            <!--<i class="fas fa-globe mr-3"></i>-->
            {{room.name}}
          </router-link>
        </li>
      </ul>
    </nav>
    <router-view ref="router" :key="$route.params.roomId"></router-view>

  </main>
</template>

<script>

import moment from 'moment';

export default {
  name: 'Property',
  data: () => ({
    title: '',
    property: {},
  }),
  mounted() {
  console.log(this.$refs.router.room());
  return;
    if(this.$refs.router){
      const propId = this.$refs.router.data.room.property;
      return;
    }else{
      const propId = this.$route.params.propertyId;
    }
    this.title = this.$store.state.host.properties.filter(p => p._id == propId)[0].name

    fetch(process.env.VUE_APP_API + '/properties?_id=' + propId, {
      method: 'get',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        "Accept-Charset": "utf-8",
        "CSRF-Token": this.$csrf
      }
    })
    .then(response => {
      return response.json();
    })
    .then(result => {
      this.property = result;
    })
  }
}
</script>
